
import { type FC, useState } from "react";
import { type Association, type Opportunity, User } from "@entities";
import { UserCardPopup } from "../popups/user-card/UserCardPopup";
import clsx from "clsx";
import OpportunityRequestsTable from "../../pages/tables/opprtunity-interested";


interface EventRequestsProps {
    eventDetails: Opportunity | undefined;
    refetchEvent?: () => void;
}

export const EventRequests: FC<EventRequestsProps> = ({
    eventDetails,
    refetchEvent,
}) => {
    const [currentUserRowData, setCurrentUserRowData] = useState<Association>();

    return (
        <div className={clsx("event-participants-container")}>
            <p className="par">בקשות הצטרפות</p>
            <OpportunityRequestsTable
                id={eventDetails?.id || ""}
                refetchEvent={refetchEvent}
            />
            <UserCardPopup
                userData={currentUserRowData}
                setUserData={setCurrentUserRowData}
            />
        </div>
    );
};